import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Routes } from "router/routes";
import { MobilePartners } from "../home/partners/MobilePartners";
import { DesktopPartners } from "../home/partners/DesktopPartners";
import { PricingFaqSection } from "./faq";
import { CreditsCalculator } from "./creditsCalculator";
import { CreditActions } from "./creditActions";

const PricingUI = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const isLoggedIn = Boolean(
    localStorage.getItem("precisionAccess") &&
    localStorage.getItem("precisionAccess") !== "undefined"
  );

  // Signed-out visitors sign up first; signed-in ones go straight to the
  // in-app top-up flow, which is the only place a charge can be created.
  const handleGetStarted = () => {
    navigate(isLoggedIn ? Routes.creditsBilling : Routes.signup);
  };

  return (
    <div className="bg-[#EFF4FA]">
      {/* Hero */}
      <section className="pt-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-16">
          <h1
            data-aos="fade-up"
            className="text-[28px] md:text-5xl lg:text-6xl font-display font-semibold text-[#00003F] lg:leading-[58px] md:leading-[40px] leading-[30px] mb-4"
          >
            Assess Candidates Efficiently with a
            Simple Credit Based System.
          </h1>
        </div>
      </section>

      <div className="max-w-[1119px] mx-auto">
        <DesktopPartners onPricing={true} />
        <MobilePartners onPricing={true} />
      </div>

      {/* Credits calculator */}
      <section className="pb-16 sm:pt-8 bg-[#EFF4FA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-aos="fade-up" data-aos-delay="150">
          <CreditsCalculator onGetStarted={handleGetStarted} />
        </div>
      </section>

      {/* What credits buy */}
      <CreditActions />

      <PricingFaqSection />
    </div>
  );
};

export { PricingUI };
